// removed by extract-text-webpack-plugin
module.exports = {"view":"style__view___1fJBn","title":"style__title___3LTDy","date":"style__date___ADT2p","subtitle":"style__subtitle___3VTk0","text":"style__text___3voAb","textTitle":"style__textTitle____jD0K","link":"style__link___3rBPo"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/terms/style.css
// module id = 114
// module chunks = 0